export const initAnimation = () => {
  const items = document.querySelectorAll("[data-animate-item]");

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-active");
        }
      });
    },
    { threshold: 0.2 },
  );

  items.forEach((el) => observer.observe(el));
};

document.addEventListener("DOMContentLoaded", () => {
  initAnimation();
});
